import Vue from "vue";
import Router from "vue-router";
import OneStudy from "@/views/dqs-one-study"
import DqsError from "@/views/dqs-error"
import AvgOfStudies from "@/views/dqs-avg-of-studies"

Vue.use(Router);

const Routes = [{
	path: '/onestudy',
	component: OneStudy,
	name: 'OneStudy'
},
{
	path: '/avgofstudies',
	component: AvgOfStudies,
	name: 'AvgOfStudies'
},
{
	path: '/error',
	component: DqsError,
	name: 'Error'
}];

export default Routes;
